/* eslint-disable */
import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import {loader } from './loader'
import i18n from '../i18n';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		/* Loader on page change */
		model:null,
		routerLoading: false,
		mainloading:false,
		alerts:[],
		/* User */
		userName: null,
		userEmail: null,
		userAvatar: null,
		token: localStorage.getItem('token') || null,
		user: null,

		/* FormScreen - fullscreen form layout (e.g. login page) */
		isFormScreen: false,

		/* Aside */
		isAsideMobileExpanded: false,
	},
	mutations: {
		SET_TOKEN(state, token) {
			state.token = token;
			axios.defaults.headers.common = {'Authorization': `Bearer ${token}`} 
			localStorage.setItem('token', token);
		},
		SET_USER(state, user) {
			state.user = user;
			if(user)
			{
				i18n.locale = user.lang.toLowerCase();
			}
			// localStorage.setItem('user', JSON.stringify(user));
		},
		SET_MODEL(state, model) {
			state.model = model;
		},
		SET_ALERTS(state, alerts) {
			state.alerts = alerts;
			// localStorage.setItem('user', JSON.stringify(user));
		},
		/* A fit-them-all commit */
		basic(state, payload) {
			state[payload.key] = payload.value;
		},

		/* User */
		user(state, payload) {
			if (payload.name) {
				state.userName = payload.name;
			}
			if (payload.email) {
				state.userEmail = payload.email;
			}
			if (payload.avatar) {
				state.userAvatar = payload.avatar;
			}
		},
	},
	actions: {
		// this.$store.dispatch('setToken', token)
		setToken({ commit }, token) {
			commit('SET_TOKEN', token);
		},
		setModel({ commit }, model) {
			commit('SET_MODEL', model);
		},
		setUser({ commit }, user) {
			commit('SET_USER', user);
		},
		setAlerts({ commit }, alerts) {
			commit('SET_ALERTS', alerts);
		},
		asideMobileToggle({ commit, state }, payload = null) {
			const isShow = payload !== null ? payload : !state.isAsideMobileExpanded;

			document
				.getElementById('app')
				.classList[isShow ? 'add' : 'remove']('ml-60');

			document.documentElement.classList[isShow ? 'add' : 'remove'](
				'm-clipped'
			);

			commit('basic', {
				key: 'isAsideMobileExpanded',
				value: isShow,
			});
		},
		formScreenToggle({ commit }, payload) {
			commit('basic', {
				key: 'isFormScreen',
				value: payload,
			});

			document.documentElement.classList[payload ? 'add' : 'remove'](
				'form-screen'
			);
		},
	},
	modules: {
		loader,
	},
});
